export default {
  tiled: require('./tiled'),
  profile: require('./profile'),
  panels: require('./panels')
}



// WEBPACK FOOTER //
// ./src/components/nav/index.js